export const TASKS = "tasks";
export const ID = "taskDependencyId";
export const TASK_NAME = "dependsOnTaskId";
export const TYPE = "dependencyType";
export const LAG_DAYS = "lagDays";
export const CATEGORY = "categoryId";
export const SUB_CATEGORY = "subCategoryId";

export const typeOptions = [
  { label: "Finish-Finish", value: "FINISH_TO_FINISH" },
  { label: "Finish-Start", value: "FINISH_TO_START" },
  { label: "Start-Finish", value: "START_TO_FINISH" },
  { label: "Start-Start", value: "START_TO_START" },
];
